var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149673",
    "data-name": "Group 149673",
    transform: "translate(-633 -352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9648",
    "data-name": "Ellipse 9648",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(633 352)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149558",
    "data-name": "Group 149558",
    transform: "translate(639.006 358.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102358",
    "data-name": "Path 102358",
    d: "M17.189,4.4H2.8A.8.8,0,1,0,2.8,6H4.4V15.59a2.4,2.4,0,0,0,2.4,2.4h6.4a2.4,2.4,0,0,0,2.4-2.4V6h1.6a.8.8,0,0,0,0-1.6ZM9.195,13.192a.8.8,0,0,1-1.6,0v-4a.8.8,0,0,1,1.6,0Zm3.2,0a.8.8,0,0,1-1.6,0v-4a.8.8,0,0,1,1.6,0ZM8.4,3.6h3.2a.8.8,0,1,0,0-1.6H8.4a.8.8,0,1,0,0,1.6Z",
    fill: "#cf0038"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.cf6c321e1f02ee4848063fdd0c4c3c15.svg";
export { ForwardRef as ReactComponent };